import constants from "../constants";

export const Header = "header";
export const Subheader = "subheader";
export const Body = "body";
export const HappyHour = "happy-hour";
export const OnSpecial = "on-special";
export const NewAdditions = "new-additions";
export const TwoForOne = "two-for-one";
export const ForTheKids = "for-the-kids";
export const HappyNewYear = "happy-new-year";
export const Since1999 = "since-1999";
export const ScanTheCode = "scan-the-code";
export const OrderOnline = "order-online";
export const GrandOpening = "grand-opening";
export const ViewOurMenu = "view-our-menu";
export const DailySpecial = "daily-special";
export const LimitedTimeOnly = "limited-time-only";
export const HappyHolidays = "happy-holidays";

export const HeaderTemplate = (font='Pathway Gothic One', size=constants.DEFAULT_FONT_SIZE_HEADER, bold=false, italic=false, underline=false) =>
`<div data-component="text" blk-v="1" inl="1" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap;">
  <div class="txt">
    <p style="font-size: ${size}0%; font-family: ${font}; line-height: 1em; text-align: center;">
      ${bold ? '<strong>' : ''}${italic ? '<em>' : ''}${underline ? '<u>' : ''}Add header${underline ? '</u>' : ''}${italic ? '</em>' : ''}${bold ? '</strong>' : ''}
    </p>
  </div>
</div>`;

export const SubheaderTemplate = (font='PT Mono', size=constants.DEFAULT_FONT_SIZE_SUBHEADER, bold=false, italic=false, underline=false) =>
  `<div data-component="text" blk-v="1" inl="1" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap;">
    <div class="txt">
      <p style=" font-size: ${size}0%; font-family: ${font}; line-height: 1em; text-align: center; ">
      ${bold ? '<strong>' : ''}${italic ? '<em>' : ''}${underline ? '<u>' : ''}Add subheader${underline ? '</u>' : ''}${italic ? '</em>' : ''}${bold ? '</strong>' : ''}
      </p>
    </div>
  </div>`;

export const BodyTemplate = (font='Futura PT', size=constants.DEFAULT_FONT_SIZE_BODY, bold=false, italic=false, underline=false) =>
  `<div data-component="text" blk-v="1" inl="1" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap;">
    <div class="txt">
      <p style=" font-size: ${size}0%; font-family: ${font}; line-height: 1em; text-align: center; ">
      ${bold ? '<strong>' : ''}${italic ? '<em>' : ''}${underline ? '<u>' : ''}Add body text${underline ? '</u>' : ''}${italic ? '</em>' : ''}${bold ? '</strong>' : ''}
      </p>
    </div>
  </div>`;

export const HappyHourTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap;  color: #EBA93F;">
    <div class="txt">
      <p style=" font-size: 600%; font-family: 'Nexa Rust Slab Black'; line-height: 1em; text-align: center; ">
        Happy Hour
      </p>
    </div>
  </div>`;

export const OnSpecialTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #47A7ED;">
    <div class="txt">
      <p style=" font-size: 400%; font-family: 'Pacifico'; line-height: 1em; text-align: center; ">
        On Special!
      </p>
    </div>
  </div>`;

export const NewAdditionsTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #B52121;">
    <div class="txt">
      <p style=" font-size: 400%; font-family: 'Lora'; line-height: 1em; text-align: center; text-transform: uppercase">
        NEW ADDITIONS
      </p>
    </div>
  </div>`;

export const TwoForOneTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #95E04B;">
    <div class="txt">
      <p style=" font-size: 600%; font-family: 'Kirang Haerang'; line-height: 1em; text-align: center; text-transform: uppercase">
        2 FOR 1 TODAY
      </p>
    </div>
  </div>`;

export const ForTheKidsTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #B065D1;">
    <div class="txt">
      <p style=" font-size: 600%; font-family: 'Gochi Hand'; line-height: 1em; text-align: center;">
        For the kids
      </p>
    </div>
  </div>`;

export const HappyNewYearTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #443576;">
    <div class="txt">
      <p style=" font-size: 600%; font-family: 'Lobster'; line-height: 1em; text-align: center;">
        Happy New Year!
      </p>
    </div>
  </div>`;

export const Since1999Template =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #F87C8F;">
    <div class="txt">
      <p style=" font-size: 400%; font-family: 'Alperton'; line-height: 1em; text-align: center;">
        Since 1999
      </p>
    </div>
  </div>`;

export const ScanTheCodeTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #333333; text-transform: uppercase">
    <div class="txt">
      <p style=" font-size: 400%; font-family: 'Anaconda'; line-height: 1em; text-align: center; text-transform: uppercase">
        Scan the Code
      </p>
    </div>
  </div>`;

export const OrderOnlineTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #745133;">
    <div class="txt">
      <p style=" font-size: 400%; font-family: 'Cherry Swash'; line-height: 1em; text-align: center;">
        Order Online
      </p>
    </div>
  </div>`;

export const GrandOpeningTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #FA8713;">
    <div class="txt">
      <p style=" font-size: 500%; font-family: 'Diplomata SC'; line-height: 1em; text-align: center;">
        Grand Opening
      </p>
    </div>
  </div>`;

export const ViewOurMenuTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #568358;">
    <div class="txt">
      <p style=" font-size: 400%; font-family: 'Mocha Mattari'; line-height: 1em; text-align: center;">
        View Our Menu
      </p>
    </div>
  </div>`;

export const DailySpecialTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #5664CC;">
    <div class="txt">
      <p style=" font-size: 600%; font-family: 'Handmade Dropshadow JNL'; line-height: 1em; text-align: center;">
        Daily Special
      </p>
    </div>
  </div>`;

export const LimitedTimeOnlyTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #EDBA31;">
    <div class="txt">
      <p style=" font-size: 400%; font-family: 'Cookie'; line-height: 1em; text-align: center;">
        Limited time only!
      </p>
    </div>
  </div>`;

export const HappyHolidaysTemplate =
  `<div data-component="text" blk-v="1" inl="1" sample-text="true" class="comp" style="display: inline-block; margin: 0; padding: 0; white-space: nowrap; color: #EA1C1C;">
    <div class="txt">
      <p style=" font-size: 600%; font-family: 'Lemon Yellow Sun'; line-height: 1em; text-align: center;">
        Happy Holidays
      </p>
    </div>
  </div>`;


export function getTextTemplate(value, font=false) {
  let fontFamily = '';
  if (font) {
    const customFontNames = constants.customFonts.map((customFont) => customFont.font);
    if (customFontNames.includes(font.name)) {
      fontFamily = font.name;
    } else {
      fontFamily = font.fontName || font.name;
    }
  }
    
  if (value === Header) {
    if (font) {
      return HeaderTemplate(fontFamily, constants.DEFAULT_FONT_SIZE_HEADER, font.bold, font.italic, font.underline);
    }
    else {
      return HeaderTemplate();
    }
  }
  if (value === Subheader) {
    if (font) {
      return SubheaderTemplate(fontFamily, constants.DEFAULT_FONT_SIZE_SUBHEADER, font.bold, font.italic, font.underline);
    }
    else {
      return SubheaderTemplate();
    }
  }
  if (value === Body) {
    if (font) {
      return BodyTemplate(fontFamily, constants.DEFAULT_FONT_SIZE_BODY, font.bold, font.italic, font.underline);
    } else {
      return BodyTemplate();
    }
  }
  if (value === HappyHour) return HappyHourTemplate;
  if (value === OnSpecial) return OnSpecialTemplate;
  if (value === NewAdditions) return NewAdditionsTemplate;
  if (value === TwoForOne) return TwoForOneTemplate;
  if (value === ForTheKids) return ForTheKidsTemplate;
  if (value === HappyNewYear) return HappyNewYearTemplate;
  if (value === Since1999) return Since1999Template;
  if (value === ScanTheCode) return ScanTheCodeTemplate;
  if (value === OrderOnline) return OrderOnlineTemplate;
  if (value === GrandOpening) return GrandOpeningTemplate;
  if (value === ViewOurMenu) return ViewOurMenuTemplate;
  if (value === DailySpecial) return DailySpecialTemplate;
  if (value === LimitedTimeOnly) return LimitedTimeOnlyTemplate;
  if (value === HappyHolidays) return HappyHolidaysTemplate;
}
